export class Navigation {
    constructor() {
        this.$toggleFallouts = $(".toggle-fallout");
        this.$shortcutToggle = $(".shortcut-toggle");
        this.menuIsOpen = false;
    }
    init() {
        this.$toggleFallouts.on("click", (ev) => this.toggleFallouts(ev));
        this.$shortcutToggle.click((e) => this.shortcutToggleClick(e));

        $('#navbarSupportedContent').on('shown.bs.collapse', () => {
                this.menuIsOpen = true;
        });

        $('#navbarSupportedContent').on('hidden.bs.collapse', (e) => {
                this.menuIsOpen = false;
        });
    }

    shortcutToggleClick(e) {
        e.preventDefault();

        const getParent = $(".nav-shortcuts");

        getParent.toggleClass("active");
    }
    
    toggleFallouts(ev) {
        ev.preventDefault();
        /* Toggle menu icon state */
        if (this.menuIsOpen) {
            this.$toggleFallouts.find(".menu-icon.menu-opened").toggleClass("menu-opened").toggleClass("menu-closed");
        } else {
            this.$toggleFallouts.find(".menu-icon.menu-closed").removeClass("menu-closed").addClass("menu-opened");
        }
    }
}



// WEBPACK FOOTER //
// ./frontend/js/components/ost.navigation.js